import React, { useMemo } from 'react';
import { Attributes, Formatters } from "../../../../../attribute/index.js";
function Renderer(props) {
  const {
    value,
    model
  } = props;
  const {
    attrName,
    objectType
  } = model;
  const attribute = Attributes.getAttribute(attrName, objectType);
  const formattedValue = useMemo(() => {
    if (value == null) {
      return null;
    }
    const formatter = model.formatter;
    return value.map(val => {
      if (!formatter) {
        return val;
      }
      return Formatters.format(val, formatter);
    }).join(', ');
  }, [value, model]);
  if (formattedValue == null || attribute == null) {
    return null;
  }
  return formattedValue;
}
export default {
  id: 'Rich.Text.Editor.CustomTextAttributeRenderer.arrayPrimitive',
  valueType: ['string*', 'int*', 'number*'],
  Component: Renderer
};